import {
  compareRealtimeOrderingInfo,
  normalizeRealtimeOrderingInfo,
} from './inplayDisplayOrderingGuard.js';

export const LIVE_SCORE_SHELL_FIELDS = [
  'live_score_home',
  'live_score_away',
  'live_period',
  'live_minute',
  'live_seconds',
  'live_clock_updated_at',
  'fixture_status',
  'fixture_status_label',
  'is_live',
  'status',
  'is_visible',
  'visible',
  'user_visible',
  'isUserVisible',
];

export const buildLiveScoreShellPatch = (source = {}) => {
  const patch = {};
  LIVE_SCORE_SHELL_FIELDS.forEach((field) => {
    if (source?.[field] !== undefined) {
      patch[field] = source[field];
    }
  });
  if (source?.authority_ts !== undefined) patch.authority_ts = source.authority_ts;
  if (source?.authorityTs !== undefined) patch.authorityTs = source.authorityTs;
  if (source?.sequence !== undefined) patch.sequence = source.sequence;
  if (source?.state_version !== undefined) patch.state_version = source.state_version;
  return patch;
};

export const hasLiveScoreShell = (source = {}) => (
  LIVE_SCORE_SHELL_FIELDS.some((field) => source?.[field] !== undefined)
);

export const isTerminalLiveScoreShell = (source = {}) => {
  const status = String(source?.status || source?.fixture_status || '').trim().toUpperCase();
  return ['CANCELLED', 'CLOSED', 'SETTLED', 'FT', 'FINISHED', 'ENDED'].includes(status);
};

export const isHiddenLiveScoreShell = (source = {}) => (
  source?.is_visible === false
  || source?.visible === false
  || source?.user_visible === false
  || source?.isUserVisible === false
  || source?.is_live === false
  || isTerminalLiveScoreShell(source)
);

export const mergeLiveScoreShellFields = (target = {}, source = {}, extra = {}) => {
  const patch = buildLiveScoreShellPatch(source);
  if (Object.keys(patch).length === 0) return target;
  return {
    ...(target || {}),
    ...patch,
    ...extra,
  };
};

export const shouldPreserveLiveScoreShell = (current = {}, incoming = {}, options = {}) => {
  const currentOrdering = normalizeRealtimeOrderingInfo(current || {});
  const incomingOrdering = normalizeRealtimeOrderingInfo(incoming || {});

  if (currentOrdering.hasOrderingSignal && incomingOrdering.hasOrderingSignal) {
    return compareRealtimeOrderingInfo(incomingOrdering, currentOrdering) < 0;
  }

  const requestStartedAt = Number(options.requestStartedAt || 0);
  const currentUpdatedAt = Number(current?._liveShellUpdatedAt || current?.updatedAt || 0);
  const currentSource = String(current?._liveShellSource || current?.source || '');
  if (
    !incomingOrdering.hasOrderingSignal
    && requestStartedAt > 0
    && currentUpdatedAt >= requestStartedAt
    && currentSource.startsWith('ws')
  ) {
    return true;
  }

  return false;
};
